import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {guideTranscriptsType} from "./__graphql-types__/index.ts";

export const GUIDE_TRANSCRIPTS_QUERY: GqlOperation<
    guideTranscriptsType["response"],
    guideTranscriptsType["variables"]
> = gqlOp(gql`
    query guideTranscripts(
        $kaid: String!
        $cursor: String
        $startDate: DateTime
        $endDate: DateTime
        $moderationStatus: ModerationStatus
        $limit: Int
    ) {
        aiGuideThreads(
            kaid: $kaid
            cursor: $cursor
            startDate: $startDate
            endDate: $endDate
            moderationStatus: $moderationStatus
            limit: $limit
        ) {
            threads {
                id
                lastUpdatedAt
                flagged
                title
                summary
                interactions {
                    id
                    pageType
                    pageTitle
                    question
                    answer
                }
                coeditingDocument {
                    id
                    title
                }
            }
            cursor
        }
    }
`);
